document.addEventListener("DOMContentLoaded", function() {
    document.querySelector(".add-cart-button").addEventListener("click", function(event) {
        event.preventDefault();
        let form = event.target.closest("form");
        let formData = new FormData(form);
        fetch('/cart/add', {
            method: 'POST',
            body: formData
        }).then(() => {
            window.location.href = '/checkout';
        });
    });
});
